// @flow

// Modules
import styled from 'styled-components';

// Styles
import { BLUE_GREY, COOL_GREY } from 'src/styles/palettes';

export default (styled.div`
  display: flex;
  padding: 5px 10px;
  margin-bottom: 2px;
  font-weight: 300;
  color: ${COOL_GREY[200]};
  background-color: ${BLUE_GREY[800]};
  border-radius: 6px;
`: any);
